<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-lg-9 col-md-12 text-left request-header">
        <div class="col-xs-8">
          <h1 class="request-title">{{ currentBoard.name }}<span v-if="adminOrOwner" v-b-modal.editBoard class="oi oi-ellipses"></span></h1>
          <span class="request-members">Members:
            <v-select v-show="showTeamSelect" label="name" :options="teamsList" v-model="team"></v-select>
            <MultiUserSelector v-show="!showTeamSelect" :parent="board" :parentPath="'board'" />
            <button class="btn btn-primary" @click="showTeamSelect = !showTeamSelect">Add users from team</button>
          </span>
        </div>
        <p>{{ currentBoard.description }}</p>
      </div>
      <div class="col-lg-3 col-md-12 text-right">
        <button class="btn btn-secondary" @click="showNewTicketModal()" href="#">New Ticket</button>
        <!-- <ShowActivity/> -->
      </div>
    </div>
    <TicketWrapper v-if="currentBoard.id" :board="currentBoard"/>
    <EditBoard :parentBoard="board"/>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import TicketWrapper from './TicketWrapper'
import MultiUserSelector from './selectors/users/MultiUserSelector.vue'
import EditBoard from './EditBoard'
export default {
  name: 'Board',
  components: {
    TicketWrapper,
    MultiUserSelector,
    EditBoard
  },
  data () {
    return {
      showTeamSelect: false,
      team: null
    }
  },
  computed: {
    ...mapGetters(['currentUser', 'teamsList', 'teams', 'currentBoard']),
    adminOrOwner () {
      if (this.currentUser.roles.includes('admin') || this.currentUser.roles.includes('manager') || this.currentBoard.owner.id === this.currentUser.id) {
        return true
      } else {
        return false
      }
    }
  },
  created () {
    this.getBoard()
  },
  mounted () {
    this.$root.$on('boardWasUpdated', () => {
      this.team = null
      this.showTeamSelect = false
      this.getBoard()
    })
    this.$root.$on('ticketWasCreated', () => {
      this.getBoard()
    })
    this.$root.$on('resetBoard', () => {
      this.getBoard()
    })
  },
  beforeDestroy () {
    this.clearListeners()
  },
  methods: {
    ...mapActions(['loadBoard']),
    addTeamUsers () {
      var vm = this
      let selectedTeam = this.teams.find(team => team.id === this.team.id)
      let userIds = selectedTeam.users.map(user => user.id)
      let boardUserIds = this.currentBoard.users.map(user => user.id)
      boardUserIds = boardUserIds.concat(userIds)
      this.$http.put('/boards/' + this.currentBoard.id, {board: {user_ids: boardUserIds}})
        .then(function (response) {
          vm.$root.$emit('boardWasUpdated', {})
        })
        .catch(e => { console.log(e) })
    },
    getBoard () {
      if (!this.$route.path.includes('boards')) return
      this.loadBoard(this.$route.params.id)
    },
    showNewTicketModal () {
      var ticket = { board_id: this.currentBoard.id, review_request: 'unrequested' }
      this.$root.$emit('ticketEdit', ticket)
    },
    clearListeners () {
      this.$root.$off('boardWasUpdated')
      this.$root.$off('ticketWasCreated')
      this.$root.$off('resetBoard')
    }
  },
  watch: {
    '$route' () {
      this.getBoard()
    },
    team: function () {
      if (this.team !== null) {
        this.addTeamUsers()
      }
    }
  }
}
</script>

<style scoped>
p {
  font-size: 10px;
}
.request-header h4 {
  margin-top: 10px;
  color: #7b7b7b;
}
h1 {
  font-weight: bold;
  font-size: 58px;
}
.oi-ellipses {
  transform: rotate(90deg) translateX(-6px);
  font-size: 30px;
}
.request-title, .request-members {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Board.vue